<template>
  <div class="dvFiltry">
    <h4>Filtruj místa</h4>

    <p>
      Zobraz na mapě body jen které mají vyplněné všechny tyto vlastnosti dle
      skupin:
    </p>
    <div class="form-check">
      <label class="form-check-label">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="filtryMista.zobrazMista"
        />
        Zobraz místa
      </label>
    </div>
    <div class="form-check">
      <label class="form-check-label">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="filtryMista.vkladatVlastniBody"
        />
        Vkládat vlastní bod
      </label>
    </div>
    <br />
    <fieldset class="mb-3 border rounded p-2">
      <legend class="float-none w-auto px-2 text-primary small">
        Zdroj dat
      </legend>

      <div class="form-check">
        <label class="form-check-label">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="filtryMista.zdroj.vlastni"
          />
          naše
        </label>
      </div>
      <div class="form-check">
        <label class="form-check-label">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="filtryMista.zdroj.park4night"
          />
          park4night
        </label>
      </div>
    </fieldset>

    <fieldset class="mb-3 border rounded p-2">
      <legend class="float-none w-auto px-2 text-primary small">
        Vybavení
      </legend>
      <div class="form-check">
        <label class="form-check-label">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="filtryMista.vybava.wc"
          />
          wc
        </label>
      </div>

      <div class="form-check">
        <label class="form-check-label">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="filtryMista.vybava.elektrina"
          />
          elektřina
        </label>
      </div>

      <div class="form-check">
        <label class="form-check-label">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="filtryMista.vybava.koupani"
          />
          koupání
        </label>
      </div>

      <div class="form-check">
        <label class="form-check-label">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="filtryMista.vybava.sprcha"
          />
          sprcha
        </label>
      </div>
    </fieldset>

    <div>
      <multiselect
        v-model="filtryMista.stitky"
        :options="dostupneStitky"
        :multiple="true"
        :taggable="true"
        label="nazev"
        track-by="id"
        placeholder="Vyber štítky"
      />
    </div>
  </div>
</template>

<script setup>
import { inject, watch, ref, onMounted } from "vue";
import { LadzoConsole as Lc } from "../js/global/ladzo-console.js";
import { Top } from "../js/class/Top.js";
import Multiselect from "vue-multiselect";

const filtryMista = inject("filtryMista");

const dostupneStitky = ref([]);
//const vybraneStitky = ref([]);

onMounted(() => {
  if (Top?.DataLayer?.StitkyMistaAll) {
    dostupneStitky.value = Top.DataLayer.StitkyMistaAll;
  } else {
    Lc.err("StitkyMistaAll nejsou dostupné.");
  }
});
watch(
  filtryMista,
  (val) => {
    Lc.log("🎛 Filtry změněny", { ...filtryMista });
    Lc.log("ssss", val);
    /*
      if (val.vkladatVlastniBody) {
      val.zobrazMista = false;
    } else {
      val.zobrazMista = true;
      }
    */
  },
  { deep: true }
);
</script>
<style scoped>
.dvFiltry {
  padding: 1em;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 1em;
}
</style>
